angular.module('components.caOrderArticles', [])
    .component('caOrderArticles', {
        templateUrl: 'main/order/orderdelivery/components/orderarticles.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            orderChangeCount: '=',
            isModifying: '<',
            order: '=',
            disabled: '<',
            onArticleSelected: '&',
            links: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $rootScope, $window, OrderService, confirmationDialogService, loadSpinnerService, OrdersApiService, Rms2OrdersApiService, OrderRowCommentDialogService, ToasterService, $translate) {
    var vm = this;

    var grid = {};
    var lastDeliveredOrderArticle = {};
    vm.currentUserClaims = $rootScope.currentUser.claims;
    vm.filteredOrderArticles = [];
    vm.hiddenDeliveredRows = false;
    vm.haveOrderArticlePurchaseCostClaim = havePurchaseCostClaim();
    vm.displayPrices = true;
    vm.ongoingRequest = false;
    vm.sortContentBy = undefined;
    vm.sortContentReverse = undefined;

    vm.restCurrentOrderArticle = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.viewOrderArticle = viewOrderArticle;
    vm.absolute = absolute;
    vm.captureGrid = captureGrid;
    vm.hideDeliveredRows = hideDeliveredRows;
    vm.isRowDelivered = isRowDelivered;
    vm.updatedQuantity = updatedQuantity;
    vm.updatedQuantityToDeliver = updatedQuantityToDeliver;
    vm.canDeliverIn = canDeliverIn;
    vm.anyNonVariantArticles = anyNonVariantArticles;
    vm.getCurrentDeliveryQuantity = getCurrentDeliveryQuantity;
    vm.getTotalQuantityLeftToDeliver = getTotalQuantityLeftToDeliver;
    vm.deliverNonVariantArticles = deliverNonVariantArticles;
    vm.isSingleVariantArticle = isSingleVariantArticle;
    vm.isMultipleVariantArticle = isMultipleVariantArticle;
    vm.deliverOrderArticle = deliverOrderArticle;
    vm.isDelivered = isDelivered;
    vm.hasOnlyOneOrderRow = hasOnlyOneOrderRow;
    vm.isRowCreated = isRowCreated;
    vm.setRestFlag = setRestFlag;
    vm.isAllowedToChangeQuantity = isAllowedToChangeQuantity;

    vm.shouldBeTreatedAsNonVariant = shouldBeTreatedAsNonVariant;
    vm.shouldBeTreatedAsVariant = shouldBeTreatedAsVariant;

    vm.openOrderRowCommentDialog = openOrderRowCommentDialog;

    function isAllowedToChangeQuantity(){
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        return !hasOrderId || vm.order.systemStatus === "created"
    }

    function hasOnlyOneOrderRow(orderArticle) {
        return orderArticle.orderRows.length === 1;
    }

    function shouldBeTreatedAsNonVariant(orderArticle) {
        return vm.isSingleVariantArticle(orderArticle.article) || (!vm.isModifying && vm.hasOnlyOneOrderRow(orderArticle))
    }

    function shouldBeTreatedAsVariant(orderArticle) {
        return !shouldBeTreatedAsNonVariant(orderArticle);
    }

    function onInit() {
        vm.filteredOrderArticles = vm.order.orderArticles;

        if (vm.order.orderArticles.length === 1 && vm.order.orderArticles[0].article && vm.shouldBeTreatedAsVariant(vm.order.orderArticles[0])) {
            viewOrderArticle(vm.order.orderArticles[0].article);
        }

        $scope.$watch(function() { return vm.orderChangeCount; }, function() {
            recalculateAggregatedData();
            hideDeliveredRows();
        });

        setInitialPriceDisplayChoice();
        setInitialQuantitiesToDeliver();
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function isDelivered(orderArticle) {
        return _.every(orderArticle.orderRows, function (orderRow) {
            return orderRow.systemStatus === 'delivered';
        });
    }

    function setRestFlag(orderArticle) {
        if ((orderArticle.orderRows[0].quantityToDeliver + orderArticle.summarizedDeliveredQuantity) >= orderArticle.orderRows[0].quantity) {
            orderArticle.restOrderArticle = false;
        }
    }

    function setInitialQuantitiesToDeliver() {
        _.forEach(vm.order.orderArticles, function(orderArticle) {
            setNextQuantityToDeliver(orderArticle);
        });
    }

    function setNextQuantityToDeliver(orderArticle) {
        if (isMultipleVariantArticle(orderArticle)) {
            return true;
        }
        orderArticle.restOrderArticle = false;
        orderArticle.deliveredDate = Date.now();
        _.forEach(orderArticle.orderRows, function(orderRow) {
            var deliveredQuantity = _.sumBy(orderRow.deliveryRows, function(deliveryRow) {
                if (deliveryRow.systemStatus === "delivered" && deliveryRow.deliveryRowType === "deliveryIn") {
                    return deliveryRow.quantity;
                }
            });
            if (deliveredQuantity === undefined) {
                deliveredQuantity = 0;
            }
            orderRow.quantityToDeliver = Math.max(orderRow.quantity - deliveredQuantity, 0);
        });
    }

    function getCurrentDeliveryQuantity() {
        var qty = _.sumBy(vm.order.orderArticles, function(orderArticle) {
            return _.sumBy(orderArticle.orderRows, function(orderRow) {
                return orderRow.quantityToDeliver;
            });
        });
        return qty;
    }

    function getTotalQuantityLeftToDeliver() {
        var sum = 0;
        _.forEach(vm.order.orderArticles, function (oa) {
            _.forEach(oa.orderRows, function (r) {
                sum += r.quantity;
            });
        })
        return sum;
    }

    function deliverOrderArticle(orderArticle)
    {
        if (vm.ongoingRequest) {
            console.log("vm.ongoingRequest: " + vm.ongoingRequest);
            return;
        }

        var deliver = function() {
            vm.ongoingRequest = true;
            lastDeliveredOrderArticle = orderArticle;
            loadSpinnerService.start('mainSpinner');

            var request = {
                orderId: vm.order.id,
                deliveringUserId: $rootScope.currentUser.id,
                lineItems: []
            }

            request.lineItems.push({
                quantity: orderArticle.orderRows[0].quantityToDeliver,
                lineNumber: orderArticle.orderRows[0].orderLineNumber,
                date: parseDate(orderArticle.deliveredDate),
                restDelivery: orderArticle.restOrderArticle
            });

            var orderSystemType = vm.order.orderType.orderSystemType;

            switch(orderSystemType) {
                case 'store':
                    deliverStoreOrder(request);
                    break;
                case 'automatic':
                    deliverAutoOrder(request);
                    break;
                case 'internal':
                    deliverInternalOrder(request);
                    break;
                case 'automaticInternal':
                    deliverAutoInternalOrder(request);
                    break;
                case 'return':
                    deliverReturnOrder(request);
                    break;
                default:
                    ToasterService.showError("Order type not recognized")
                    throw new Error("Order type not recognized", orderSystemType);
            }

            function deliverStoreOrder(request) {
                Rms2OrdersApiService.deliverStoreOrder(request).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    reloadOrder();
                },function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }

            function deliverAutoOrder(request) {
                Rms2OrdersApiService.deliverAutoOrder(request).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    reloadOrder();
                },function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }

            function deliverInternalOrder(request) {
                Rms2OrdersApiService.deliverInternalOrder(request).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    reloadOrder();
                },function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }

            function deliverAutoInternalOrder(request) {
                Rms2OrdersApiService.deliverAutoInternalOrder(request).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    reloadOrder();
                },function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }

            function deliverReturnOrder(request) {
                Rms2OrdersApiService.deliverReturnOrder(request).then(function(response) {
                    ToasterService.showSuccess($translate.instant("common.done"));
                    reloadOrder();
                },function(error) {
                    ToasterService.showError(error.message);
                }).finally(function() {
                    vm.ongoingRequest = false;
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        }

        if(orderArticleHasRowsWithPurchaseCostLargerThanSalesPrice(orderArticle)){
            confirmationDialogService.showDialog($translate.instant("order.purchasecostIsLargerMessage"), 'danger').then(function (result) {
                if (result === true) {
                    deliver();
                }
            });
        }
        else {
            deliver();
        }
    }

    function orderArticleHasRowsWithPurchaseCostLargerThanSalesPrice(orderArticle){
        return orderArticle.orderRows.some(function(orderRow){
            return orderRow.systemStatus !== 'delivered' && 
                orderRow.systemStatus !== 'voided' &&
                orderRow.purchaseCost > orderRow.articleVariant.salesPrice
        });
    }

    function reloadOrder() {
        var orderId = vm.order.id;

        OrdersApiService.getById(orderId).then(function(response) {

            // Keep previous delivery input
            _.forEach(vm.order.orderArticles, function (oldOrderArticle) {
                var newOrderArticle = _.find(response.data.order.orderArticles, function(newOrderArticle) {
                    return newOrderArticle.article.id === oldOrderArticle.article.id;
                });
                newOrderArticle.orderRows[0].quantityToDeliver = oldOrderArticle.orderRows[0].quantityToDeliver;
            });

            vm.order = response.data.order;
            vm.order.deliveredDate = new Date();
            vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);
            var orderArticle = _.find(vm.order.orderArticles, function(orderArticle) { return orderArticle.article.id === lastDeliveredOrderArticle.article.id });
            setNextQuantityToDeliver(orderArticle);

            vm.orderChangeCount += 1;
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }

    function deliverNonVariantArticles() {
        if (vm.ongoingRequest) {
            console.log("vm.ongoingRequest: " + vm.ongoingRequest);
            return;
        }
        vm.ongoingRequest = true;

        var orderCopy = angular.copy(vm.order);

        var nonVariantOrderArticles = _.filter(orderCopy.orderArticles, function(orderArticle) {
            // return !orderArticle.article.isVariant;
            return isSingleVariantArticle(orderArticle.article)
        });

        _.forEach(nonVariantOrderArticles, function(orderArticle) {
            orderArticle.shouldDeliverThisArticle = true;
            orderArticle.orderRows[0].quantity = orderArticle.orderRows[0].quantityToDeliver;
        });

        zeroAllNonDeliveryQuantities(orderCopy);
        stripUnnecessaryOrderData(orderCopy);

        deliverOrderArticle();

        function deliverOrderArticle() {
            loadSpinnerService.start('mainSpinner');
            OrdersApiService.deliverPartially(orderCopy).then(function(response) {
                vm.order = response.data;
                vm.order.deliveredDate = new Date();
                vm.order.plannedDeliveryDate = parseDate(vm.order.plannedDeliveryDate);
                setInitialQuantitiesToDeliver();

                vm.orderChangeCount += 1;
            }, function(error) {
                ToasterService.showError(error.message);
            }).finally(function() {
                vm.ongoingRequest = false;
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function parseDate(input) {
		if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
		} else {
			return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
		}
	}

    function zeroAllNonDeliveryQuantities(order) {
        _.forEach(order.orderArticles, function(orderArticle) {
            if (!orderArticle.shouldDeliverThisArticle) {
                _.forEach(orderArticle.orderRows, function(orderRow) {
                    orderRow.quantity = 0;
                });
            }
        });
    }

    function stripUnnecessaryOrderData(order) {
        order.orderArticles = _.filter(order.orderArticles, function(oa) { return oa.shouldDeliverThisArticle && oa.shouldDeliverThisArticle === true; });
        _.forEach(order.orderArticles, function(orderArticle) {
            orderArticle.article = undefined;
            _.forEach(orderArticle.orderRows, function (ordRow) {
                _.forEach(ordRow.deliveryRows, function(delRow) {
                    if (delRow.location) { delRow.location = { id: delRow.location.id }; }
                    if (delRow.deliveringUser) { delRow.deliveringUser = { id: delRow.deliveringUser.id }; }
                    if (delRow.articleVariant) { delRow.articleVariant = { id: delRow.articleVariant.id }; }
                });
            });
        });
        if (order.purchaser) { order.purchaser = { id: order.purchaser.id }; }
        if (order.destination) { order.destination = { id: order.destination.id }; }
        if (order.company) { order.company = { id: order.company.id }; }
        if (order.user) { order.user = { id: order.user.id }; }
        if (order.collection) { order.collection = { id: order.collection.id }; }
        if (order.fromLocation) { order.fromLocation = { id: order.fromLocation.id }; }
    }

    function setInitialPriceDisplayChoice() {
        var windowWidthLimit = 1485;
        var windowTooNarrow = $window.innerWidth < windowWidthLimit;
        var isDelivering = !vm.isModifying;

        if (vm.isModifying) {
            vm.displayPrices = true;
        } else if (isDelivering && windowTooNarrow) {
            vm.displayPrices = false;
        }
    }

    function canDeliverIn() {
        return OrderService.canPartDeliverOrder(vm.links);
    }

    function isSingleVariantArticle(article) {
        return !article.isVariant || (article.articleVariants !== undefined && article.articleVariants.length < 2);
    }

    function isMultipleVariantArticle(article) {
        return !isSingleVariantArticle(article);
    }

    function anyNonVariantArticles() {
        // var value = vm.order.orderArticles.some(function(e) { return isSingleVariantArticle(e.article); });
        var value = vm.order.orderArticles.some(function(orderArticle) { return shouldBeTreatedAsNonVariant(orderArticle); });
        return value;
    }

    function havePurchaseCostClaim(){
        if(vm.currentUserClaims.seepurchasecost === undefined){
           return false
        }

        if(!vm.currentUserClaims.seepurchasecost.read){
            return false
        }

        return true
    }

    function captureGrid(s) {
        grid = s;
    }

    function viewOrderArticle(article, lowestStatusAmongRows) {
        if(isRowDelivered(lowestStatusAmongRows)){
            return
        }

        vm.onArticleSelected({article: article});
    }

    function isRowDelivered(lowestStatusAmongRows){
        if(lowestStatusAmongRows !== "delivered"){
            return false
        }

        return true
    }

    function isRowCreated(lowestStatusAmongRows) {
        if (lowestStatusAmongRows === "created") {
            return true;
        }

        return false;
    }

    function absolute(number) {
        if (_.isNumber(number)) {
            return Math.abs(number);
        }
        return 0;
    }

    function hideDeliveredRows() {
        if (vm.hiddenDeliveredRows) {
            vm.filteredOrderArticles = _.filter(vm.order.orderArticles, function(art) {
                return art.lowestSystemStatusAmongRows !== 'delivered';
            });
        } else {
            vm.filteredOrderArticles = vm.order.orderArticles;
        }
    }

    function recalculateAggregatedData() {
        _.forEach(vm.order.orderArticles, function(orderArticle) {
            orderArticle.summarizedPurchaseCost = 0;
            orderArticle.summarizedSalesPrice = 0;
            orderArticle.summarizedQuantity = 0;
            orderArticle.summarizedDeliveredQuantity = 0;

            var zeroQuantityAverageOrderRowPurchaseCost = 0;
            var zeroQuantityAverageOrderRowSalesPrice = 0;
            var nonZeroQuantityOrderRowPurchaseCost = 0;
            var nonZeroQuantityOrderRowSalesPrice = 0;
            var nonZeroQuantityOrderRowsCount = 0;

            _.forEach(orderArticle.orderRows, function(orderRow) {
                orderArticle.summarizedPurchaseCost += orderRow.quantity * orderRow.purchaseCost;
                if(orderRow.quantity > 0){
                    nonZeroQuantityOrderRowPurchaseCost += orderRow.purchaseCost;
                    nonZeroQuantityOrderRowSalesPrice += orderRow.articleVariant.salesPrice;
                    nonZeroQuantityOrderRowsCount++;
                }
                orderArticle.summarizedSalesPrice += orderRow.articleVariant.salesPrice * orderRow.quantity;
                orderArticle.summarizedQuantity += orderRow.quantity;

                zeroQuantityAverageOrderRowPurchaseCost += orderRow.purchaseCost;
                zeroQuantityAverageOrderRowSalesPrice += orderRow.articleVariant.salesPrice;

                _.forEach(orderRow.deliveryRows, function(deliveryRow) {
                    if (deliveryRow.systemStatus === 'delivered' && deliveryRow.deliveryRowType === 'deliveryIn') {
                         orderArticle.summarizedDeliveredQuantity += deliveryRow.quantity;
                    } else if (vm.order.orderType.orderSystemType == 'return' && deliveryRow.deliveryRowType === 'deliveryOut' && deliveryRow.systemStatus === 'delivered') {
                        orderArticle.summarizedDeliveredQuantity += -deliveryRow.quantity;
                    }
                });
            });

            orderArticle.averageOrderRowPurchaseCost = nonZeroQuantityOrderRowPurchaseCost / nonZeroQuantityOrderRowsCount;

            if (_.isNaN(orderArticle.averageOrderRowPurchaseCost)) {
                orderArticle.averageOrderRowPurchaseCost = zeroQuantityAverageOrderRowPurchaseCost / orderArticle.orderRows.length;
                if (_.isNaN(orderArticle.averageOrderRowPurchaseCost)) {
                    orderArticle.averageOrderRowPurchaseCost = "";
                }
            }

            orderArticle.averageArticleVariantSalesPrice = nonZeroQuantityOrderRowSalesPrice / nonZeroQuantityOrderRowsCount;

            if(_.isNaN(orderArticle.averageArticleVariantSalesPrice)){
                orderArticle.averageArticleVariantSalesPrice = zeroQuantityAverageOrderRowSalesPrice / orderArticle.orderRows.length;
                if (_.isNaN(orderArticle.averageArticleVariantSalesPrice)) {
                    orderArticle.averageArticleVariantSalesPrice = "";
                }
            }

            orderArticle.summarizedDeliveredCost = absolute(orderArticle.averageOrderRowPurchaseCost * orderArticle.summarizedDeliveredQuantity);
            if(shouldBeTreatedAsNonVariant(orderArticle)){
                orderArticle.nonVariantVariantDetail1Name = orderArticle.orderRows[0].articleVariant.variantDetail1.variantDetailName;
                orderArticle.nonVariantVariantDetail2Name = orderArticle.orderRows[0].articleVariant.variantDetail2.variantDetailName;
                orderArticle.nonVariantQuantityToDeliver = orderArticle.orderRows[0].quantityToDeliver;
            }
            else{
                orderArticle.nonVariantVariantDetail1Name = "";
                orderArticle.nonVariantVariantDetail2Name = "";
                orderArticle.nonVariantQuantityToDeliver = 0;
            }
        });
    }

    //Transform from string to Date, and make sure date has correct timezone and no time information
	function parseDate(input) {
		if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
		} else {
			return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
		}
	}

    function updatedQuantity() {
        vm.orderChangeCount += 1;
        
        _.forEach(vm.filteredOrderArticles, function(orderArticle){
            if(shouldBeTreatedAsNonVariant(orderArticle)){
                orderArticle.orderRows[0].quantity = orderArticle.orderRows[0].quantity < 0 ? 0 : orderArticle.orderRows[0].quantity;
            }
        });
    }

    function updatedQuantityToDeliver(){
        vm.orderChangeCount += 1;
        
        _.forEach(vm.filteredOrderArticles, function(orderArticle){
            if(shouldBeTreatedAsNonVariant(orderArticle)){
                orderArticle.orderRows[0].quantityToDeliver = orderArticle.orderRows[0].quantityToDeliver < 0 ? 0 : orderArticle.orderRows[0].quantityToDeliver;
            }
        });
    }

    function refreshGrid() {
        if (grid.invalidate) {
            grid.invalidate();
        }
        if (grid.collectionView) {
            grid.collectionView.refresh();
        }
    }

    function openOrderRowCommentDialog(orderArticle) {
        console.log(vm.isModifying);
        OrderRowCommentDialogService.showDialog(orderArticle)
        .then(function (result){
            if(result){
                vm.orderChangeCount += 1;
                orderArticle.orderRows = result;

                if(!vm.isModifying){
                    loadSpinnerService.start('mainSpinner');
                    Rms2OrdersApiService.updateCommentOnOrderRows(orderArticle.orderRows).then(function(response) {
                        ToasterService.showSuccess();
                    }, function(error) {
                        ToasterService.showError(error.message);
                    }).finally(function() {
                        vm.ongoingRequest = false;
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            }
        });
    }
}
